import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {useState} from 'react';
import {CreateRegionDTO, useRegions} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseAddRegionFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddRegionForm = ({setOpen}: UseAddRegionFormProps) => {
  const {regionNameSchema} = useSchemes();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createRegionMutation} = useRegions();

  const onSubmit = async (values: CreateRegionDTO) => {
    setErrorMessage(null);
    try {
      await createRegionMutation.mutateAsync(values);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании региона');
    }
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      order: 0,
    },
    validationSchema: Yup.object({
      name: regionNameSchema,
      order: Yup.number().required('Порядок отображения обязателен'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createRegionMutation.isPending,
    submitError: createRegionMutation.error
      ? (createRegionMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
